import { getListComboByKey } from './systemkey'

export interface SystemKeyNumberOption {
  value: number
  label: string
}

/** Con của một systemkey → option số: value = codeValue (lưu ở cột), label = description. */
export const getNumberOptionsByKey = (
  key: string,
  listSystemKey: unknown[]
): SystemKeyNumberOption[] =>
  (getListComboByKey(key, listSystemKey as never[]) ?? []).map(
    (item: { codeValue: string | number; description: string }) => ({
      value: Number(item.codeValue),
      label: item.description,
    })
  )
